import React from 'react';
import { Row } from '@ioip/core/lib/components';
import { UXField } from './UXField';
import { IPFieldProps } from '../../types/field-props';
import CRow from '../types/CRow';

export const UXRow = (props: IPFieldProps<CRow>): JSX.Element => {

    const children = props.field.children.where(x => x.visible).toArray();
    if (children.length == 0)
        return <></>

    return <Row>
        {children.map(f => <UXField
            {...props}
            key={f.id.toString()}
            field={f}
        />)}
    </Row>
}